import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { CSVLink } from "react-csv";
import toast from "react-hot-toast";
import ShippersPackingService from "../services/ShippersPackingService";
import ReportService from "../services/ReportService";
import { useBrand } from "./../helper/BrandContext";

const ShippersPackingRpt = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const shippersPackingService = new ShippersPackingService();
  const reportService = new ReportService();
  const surveyLink = useRef(null);
  const ref = useRef(null);
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    SeqNoSearch: 0,
    PageSize: 10,
    SortColumn: "ScannedDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    SeqNoSearch: "",
    sortOrder: "",
    shippersData: []
  });
  const navigate = useNavigate();
  const [triggerDownload, setTriggerDownload] = useState(false);

  const handleButtonClick = async (row) => {
    shippersPackingService
      .shippersDetails(row.cartonId)
      .then((response) => {
        const data = response;
        setState((prevData) => ({
          ...prevData,
          shippersData: data,
          loading: false
        }));
      })
      .catch((error) => {
        console.error("API request failed:", error);
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  };

  function GetShipperPackingRpt() {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    reportService
      .shippersReport(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (
      (name === "FromDate" || name === "ToDate") &&
      !(value instanceof Date)
    ) {
      toast.error(
        `Please select a valid ${name === "FromDate" ? "from" : "to"} date.`
      );
      return;
    }

    if (name === "FromDate" && value > state.ToDate) {
      toast.error("From date must be less than to date.");
      return;
    }

    if (name === "ToDate" && value < state.FromDate) {
      toast.error("To date must be greater than from date.");
      return;
    }

    setState((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const FilterData = () => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    tableRequest.FromDate = state.FromDate.toLocaleDateString();
    tableRequest.ToDate = state.ToDate.toLocaleDateString();
    tableRequest.SeqNoSearch = state.SeqNoSearch || 0;
    GetShipperPackingRpt();
  };

  const GetReportExport = () => {
    tableRequest.PageSize = -1;
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    reportService
      .shippersReport(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const filteredData = data.responseData.map(
            ({ totalRows, ...rest }) => rest
          );
          setState((prevData) => ({
            ...prevData,
            allData: filteredData,
            loading: false
          }));
          setTriggerDownload(true);
          // Trigger the CSV download
        } else {
          setState((prevData) => ({
            ...prevData,
            allData: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to export data");
      });
  };

  const searchFilter = (e) => {
    const value = e.target.value;
    setState((prevData) => ({
      ...prevData
      //loading: true
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    //GetShipperPackingRpt();
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    GetShipperPackingRpt();
  };

  const onPage = (event) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    GetShipperPackingRpt();
  };

  const onRowClick = (e) => {
    const rowData = e.data;
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    handleButtonClick(rowData);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
    var date = new Date();
    date.setDate(date.getDate() - 7);
    tableRequest.FromDate = date.toLocaleDateString();
    tableRequest.ToDate = new Date().toLocaleDateString();
    setState((prevData) => ({
      ...prevData,
      FromDate: date,
      ToDate: new Date()
    }));
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    if (brand) {
      tableRequest.brandId = brand;
      GetShipperPackingRpt();
    }
  }, [brand]);

  useEffect(() => {
    if (triggerDownload) {
      surveyLink.current.link.click();
      setTriggerDownload(false); // Reset the trigger after download
    }
  }, [triggerDownload]);

  const onIndexTemplate = (data, props) => {
    return state.first + props.rowIndex + 1;
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Shippers Packing Report
        </h1>
      </div>

      <div className="date-picker-container flex items-center mb-4 md:mb-0">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="text"
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                SeqNoSearch: e.target.value
              }))
            }
            value={state.SeqNoSearch || ""}
            placeholder="Serial No."
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        {/* <div className="search-container flex items-center mr-4">
          <TextField
            type="text"
            onChange={(e) => setState(prevState => ({ ...prevState, SeqNoSearch: e.target.value }))}
            value={state.SeqNoSearch || ''}
            placeholder="SeqNo Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> 
        </div> */}
        <Calendar
          value={state.FromDate || undefined}
          name="FromDate"
          onChange={handleChange}
          appendTo={document.getElementById("root")}
          placeholder="From Date"
          className="p-inputtext-sm mr-2"
        />
        <Calendar
          value={state.ToDate || undefined}
          name="ToDate"
          onChange={handleChange}
          appendTo={document.getElementById("root")}
          placeholder="To Date"
          className="p-inputtext-sm mr-2"
        />
      </div>
      <div className="search-export-container flex items-center  mb-4 md:mb-0">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        <button
          type="button"
          onClick={FilterData}
          className="ml-3 mr-3 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Submit
        </button>
        <button
          target="_blank"
          disabled={!state.sales.length}
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          onClick={GetReportExport}
        >
          Export
        </button>
        <CSVLink
          hidden={true}
          data={state.allData}
          ref={surveyLink}
          filename={"Shippers Packing Report.csv"}
        >
          Export
        </CSVLink>
      </div>
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <DataTable
              exportFilename="Shipper Packing Report"
              responsive={true}
              header={header}
              globalFilter={state.globalFilter}
              emptyMessage={state.emptyMessage}
              value={state.sales}
              paginator={true}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              rows={state.rows}
              rowsPerPageOptions={[10, 50, 200, 500]}
              totalRecords={state.totalRecords}
              lazy={true}
              first={state.first}
              onPage={onPage}
              onSort={onSort}
              onRowClick={onRowClick}
              className="p-datatable-responsive"
              scrollable={true} // Add this line to enable horizontal scrolling
            >
              <Column
                field="Index"
                header="Sr No"
                body={onIndexTemplate}
                style={{ width: "80px", "word-wrap": "break-word" }}
              />
              <Column
                field="cartonId"
                header="Carton Id"
                sortable={false}
                bodyClassName="text-blue-500 hover:cursor-pointer"
                style={{ width: "100px" }}
              />
              <Column
                field="totalProducts"
                header="No. Of Products"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="productName"
                header="Product Name"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="batchNo"
                header="Batch No"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="packedBy"
                header="Packed By"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="packedAt"
                header="Packed At"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="scannedDate"
                header="Packed Date"
                sortable={true}
                style={{ width: "100px" }}
              />
            </DataTable>

            <h1
              className="reports_head text-xl font-semibold text-gray-800 mr-4 mt-4"
              ref={ref}
            >
              Shippers Details
            </h1>
            <DataTable
              value={state.shippersData}
              emptyMessage="No shippers data available"
              className="p-datatable-responsive mt-4"
              scrollable={true} // Add this line to enable horizontal scrolling
            >
              <Column
                field="seqNo"
                header="SeqNo"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="productName"
                header="Product Name"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="batchNo"
                header="Batch No"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="mappedBy"
                header="Mapped By"
                sortable={false}
                style={{ width: "100px" }}
              />
              <Column
                field="mappedDate"
                header="Mapped Date"
                sortable={false}
                style={{ width: "100px" }}
              />
            </DataTable>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShippersPackingRpt;
